import { makeQuery } from 'shared/utilities';
import { IEntryPassModel } from 'shared/models';

type ResponseType = {
    pages: number;
    items: IEntryPassModel[];
};

export const entryPassesQuery = async function (params?: {query?: string, sort?: null | string}) {
    return await makeQuery<ResponseType>('/entry-passes', { params });
}
